/**
 * Guest fields may live on `data.guest` or on `data` root depending on CRM payload shape.
 */
export const getGuestRecordFromProfileData = (data) => {
  if (!data || typeof data !== 'object') return {};
  if (data.guest != null && typeof data.guest === 'object') {
    return { ...data.guest };
  }
  return { ...data };
};

/**
 * Merges Obee PUT …/update-by-id response into CRM guest profile `data` (shape: `{ guest?: object }`).
 * Obee returns snake_case; CRM UI often reads camelCase — set common aliases.
 */
export const mergeObeeUpdateIntoGuestProfileData = (prevData, updatePayload) => {
  const prev = prevData && typeof prevData === 'object' ? { ...prevData } : {};
  const obeeGuest = updatePayload?.guest ?? updatePayload;
  if (!obeeGuest || typeof obeeGuest !== 'object') {
    return prevData ?? {};
  }

  const prevGuest = getGuestRecordFromProfileData(prev);
  const mergedGuest = { ...prevGuest, ...obeeGuest };

  if (obeeGuest.first_name != null) mergedGuest.firstName = obeeGuest.first_name;
  if (obeeGuest.last_name != null) mergedGuest.lastName = obeeGuest.last_name;

  return { ...prev, guest: mergedGuest };
};

/**
 * When getCRMGuestProfile returns after an Obee save, the snapshot can briefly lag behind.
 * Overlay existing Redux `guest` (already merged from UPDATE_OBEE_GUEST_SUCCESS) on top of the fetch
 * so in-session edits stay visible until the next full reload.
 */
export const mergeFetchedGuestProfile = (prevData, incomingData) => {
  const prev = prevData && typeof prevData === 'object' ? { ...prevData } : {};
  const incoming = incomingData && typeof incomingData === 'object' ? { ...incomingData } : {};
  const prevGuest = getGuestRecordFromProfileData(prev);
  const incomingGuest = getGuestRecordFromProfileData(incoming);
  const guest = { ...incomingGuest, ...prevGuest };

  return {
    ...prev,
    ...incoming,
    guest,
  };
};
